import localforage from 'localforage';
import axios from 'axios';

localforage.config({
    name: 'TaxEases',
    storeName: 'tdsData',
});

// Basic localforage methods
export const getLegacyStorageKey = (formType, baseKey) => {
    const cid = localStorage.getItem('activeClientId') || 'guest';
    const fy = localStorage.getItem('tdsFinancialYear') || 'default_fy';
    const qtr = localStorage.getItem('tdsQuarter') || 'default_qtr';
    return `${formType}_${cid}_${fy}_${qtr}_${baseKey}`;
};

export const setLocalItem = async (key, value) => {
    try {
        await localforage.setItem(key, value);
    } catch (error) {
        console.error('Error setting localforage item:', error);
    }
};

export const getLocalItem = async (key) => {
    try {
        const value = await localforage.getItem(key);
        return value;
    } catch (error) {
        console.error('Error getting localforage item:', error);
        return null;
    }
};

export const removeStorageItem = async (key) => {
    try {
        await localforage.removeItem(key);
    } catch (error) {
        console.error('Error removing localforage item:', error);
    }
};

// Dual-Mode Sync Methods
export const setStorageItem = async (key, value) => {
    const token = localStorage.getItem('premiumToken');
    
    if (token) {
        // 1. Premium User: ONLY save to cloud, completely bypass local browser storage
        try {
            await axios.post('/api/data/save', 
                { key, data: value },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            console.log(`[Sync] Saved ${key} to cloud`);
        } catch (error) {
            console.error(`[Sync] Failed to save ${key} to cloud`, error);
        }
    } else {
        // 2. Guest User: Save locally for immediate UI responsiveness
        await setLocalItem(key, value);
    }
};

export const getStorageItem = async (key) => {
    const token = localStorage.getItem('premiumToken');
    
    if (token) {
        // 1. Premium User: ONLY fetch from cloud, DO NOT look in local browser storage
        try {
            const res = await axios.get(`/api/data/get/${key}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.success && res.data.data) {
                return res.data.data;
            }
        } catch (error) {
            console.error(`[Sync] Failed to fetch ${key} from cloud`, error);
        }
        return null; // Return null if cloud fetch fails, ensuring we never mix with guest data
    }
    
    // 2. Fallback to local storage (localforage)
    let val = await getLocalItem(key);
    
    // 3. Migrate from old localStorage if necessary
    if (!val) {
        const oldVal = localStorage.getItem(key);
        if (oldVal) {
            try {
                val = JSON.parse(oldVal);
            } catch(e) {
                val = oldVal;
            }
            // Save to localforage and remove from old localStorage to prevent 5MB limits
            await setLocalItem(key, val);
            localStorage.removeItem(key);
        }
    }
    
    return val;
};
